module.exports = __webpack_public_path__ + "assets/img/lbft.8ec84605.png";